import { render } from "./speakers.vue?vue&type=template&id=d34bb58e&scoped=true"
import script from "./speakers.vue?vue&type=script&lang=js"
export * from "./speakers.vue?vue&type=script&lang=js"

import "./speakers.vue?vue&type=style&index=0&id=d34bb58e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d34bb58e"

export default script